import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

/**
 * Dialog riutilizzabile che mostra documenti legali quandomiserve.it.
 * Props:
 *   - isOpen: bool
 *   - onOpenChange: fn
 *   - termsType: 'user' | 'business' | 'privacy'
 */
const TermsDialog = ({ isOpen, onOpenChange, termsType = 'user' }) => {
  const [data, setData] = useState({ text: '', version: '', last_update: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) return undefined;
    let cancelled = false;
    const fetchTerms = async () => {
      setLoading(true);
      try {
        const url = termsType === 'privacy'
          ? `${API}/legal/privacy-policy`
          : `${API}/legal/terms/${termsType}`;
        const res = await axios.get(url);
        if (!cancelled) setData(res.data || {});
      } catch (e) {
        if (!cancelled)
          setData({
            text: 'Impossibile caricare il testo. Riprova più tardi.',
            version: '',
            last_update: '',
          });
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchTerms();
    return () => {
      cancelled = true;
    };
  }, [isOpen, termsType]);

  const title = termsType === 'business'
    ? 'Termini e Condizioni per le Aziende'
    : termsType === 'privacy'
      ? 'Privacy Policy'
      : 'Termini e Condizioni di Utilizzo';

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-3xl max-h-[85vh] overflow-hidden flex flex-col p-0"
        data-testid={`terms-dialog-${termsType}`}
      >
        {/* Brand header con logo trasparente */}
        <div className="bg-white px-6 py-4 border-b border-slate-200 flex items-center">
          <img
            src="/logo-quandomiserve-dark.png"
            alt="quandomiserve.it"
            className="h-8 sm:h-10 w-auto object-contain"
            data-testid="terms-brand-logo"
          />
        </div>

        <div className="px-6 pt-4 pb-2">
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
            <DialogDescription>
              {data.last_update
                ? `Ultimo aggiornamento: ${data.last_update}${data.version ? ` (versione ${data.version})` : ''}`
                : 'Documento legale quandomiserve.it'}
            </DialogDescription>
          </DialogHeader>
        </div>

        <div
          className="flex-1 overflow-y-auto border-t border-b border-slate-200 mx-6 rounded-lg p-4 bg-slate-50 text-sm text-slate-700 whitespace-pre-wrap leading-relaxed"
          data-testid="terms-text"
        >
          {loading ? 'Caricamento in corso...' : data.text}
        </div>

        <div className="flex justify-end pt-4 pb-6 px-6">
          <Button
            type="button"
            onClick={() => onOpenChange(false)}
            className="bg-gradient-to-r from-orange-600 to-red-600 hover:from-orange-700 hover:to-red-700"
            data-testid="terms-close-btn"
          >
            Chiudi
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TermsDialog;
